if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

function init() {
  document
    .querySelectorAll(".hw-collection_description")
    .forEach((description) => {
      const showMore = description.parentElement?.querySelector(
        ".hw-collection_description__show-more",
      );

      if (!showMore) return;

      // Only show the toggle when the description actually overflows two lines.
      if (description.scrollHeight <= description.clientHeight + 1) {
        showMore.style.display = "none";
        return;
      }

      showMore.addEventListener("click", () => {
        const isOpen = description.classList.toggle(
          "hw-collection_description--open",
        );
        showMore.textContent = isOpen ? "Show Less..." : "Show More...";
      });
    });
}
